import { ReviewTemplate } from './components/review-assessment-sections/review-assessment-sections.component'

export const HM_REVIEW_TEMPLATE: ReviewTemplate = {
   reviewType: 'HM',
   sections: [
      {
         id: 'section_job_description',
         revieweeTitle: 'Hospital Manager Job Description',
         reviewerTitle: '',
         questions: [
            {
               id: 'job_description_reviewed',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'I have reviewed my current job description in Skyworld.',
                     value: 'reviewed_job_description',
                  },
               ],
               revieweeLabel:
                  'Please review your updated job description in Skyworld using the link below. The job description will open in a new browser tab. After reviewing it, return to this self-assessment (your original tab) and confirm that you’ve reviewed the job description by checking the box below.<span class="required-asterisk">&nbsp;*</span><p></p><p><a href="https://vetcor.skyworld.com/userfilesV3/files/Hospital%20Manager%20Job%20Description%202026.pdf" target="_blank">HM Job Description 2026 &nbsp;&nbsp;<i class="fa fa-external-link-alt"></i></a></p>',
               maxSelections: 1,
               labelIsHtml: true,
               reviewerLabel: '',
            },
         ],
      },

      // A. Role Satisfaction & Engagement
      {
         id: 'section_a',
         revieweeTitle: 'Role Satisfaction & Engagement',
         reviewerTitle: 'Role Satisfaction & Engagement',
         questions: [
            {
               id: 'role_satisfaction_engagement',
               type: 'radio',
               required: true,
               revieweeLabel: 'How satisfied and engaged are you in your Hospital Manager role?',
               revieweeOptions: [
                  { label: 'Very satisfied', value: 'very_satisfied' },
                  { label: 'Satisfied', value: 'satisfied' },
                  { label: 'Neutral', value: 'neutral' },
                  { label: 'Somewhat dissatisfied', value: 'somewhat_dissatisfied' },
                  { label: 'Dissatisfied', value: 'dissatisfied' },
               ],
               reviewerLabel: 'HM engagement and ownership in their role',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'role_factors',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Team support', value: 'team_support' },
                  { label: 'Partnership with Chief of Staff', value: 'partnership_cos' },
                  { label: 'Partnership with Regional Manager', value: 'partnership_rm' },
                  { label: 'Autonomy/ownership', value: 'autonomy_ownership' },
                  { label: 'Work–life balance', value: 'work_life_balance' },
                  { label: 'Staffing stability', value: 'staffing_stability' },
                  { label: 'Workload sustainability', value: 'workload_sustainability' },
                  { label: 'Feeling valued', value: 'feeling_valued' },
               ],
               revieweeLabel: 'What factors influence your experience the most? (Select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: '',
            },
            {
               id: 'team_motivation_positive',
               type: 'radio',
               required: true,
               reviewerLabel: 'HM ability to foster a motivated, positive team',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               revieweeLabel: '',
            },
            {
               id: 'role_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes (examples of behaviors that reflect your engagement or ownership this year)',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // B. Leadership & Team Culture
      {
         id: 'section_b',
         revieweeTitle: 'Leadership & Team Culture',
         reviewerTitle: 'Leadership & Team Culture',
         questions: [
            {
               id: 'leadership_effectiveness',
               type: 'radio',
               required: true,
               revieweeLabel: 'How would you describe your leadership effectiveness this year?',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               reviewerLabel: 'HM sets clear expectations and models leadership behaviors',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'leadership_practices',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Coaching & development', value: 'coaching_development' },
                  { label: 'Clear expectations & accountability', value: 'clear_expectations_accountability' },
                  { label: 'Recognition & appreciation', value: 'recognition_appreciation' },
                  { label: 'Approachability & psychological safety', value: 'approachability_psych_safety' },
                  { label: 'Leading by example', value: 'leading_by_example' },
                  { label: 'Supporting team engagement', value: 'supporting_team_engagement' },
                  { label: 'Partnering effectively with COS', value: 'partnering_with_cos' },
               ],
               revieweeLabel: 'Which practices do you demonstrate consistently? (Select up to 3)',
               maxSelections: 3,
               reviewerLabel: 'Leadership behaviors consistently demonstrated (Select up to 3)',
            },
            {
               id: 'leadership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // C. Team Development & Retention
      {
         id: 'section_c',
         revieweeTitle: 'Team Development & Retention',
         reviewerTitle: 'Team Development & Retention',
         questions: [
            {
               id: 'team_build_retain_confidence',
               type: 'radio',
               required: true,
               revieweeLabel: 'How confident are you in building and retaining a strong team?',
               revieweeOptions: [
                  { label: 'Very confident', value: 'very_confident' },
                  { label: 'Confident', value: 'confident' },
                  { label: 'Somewhat confident', value: 'somewhat_confident' },
                  { label: 'Not confident yet', value: 'not_confident_yet' },
               ],
               reviewerLabel: 'HM builds and retains a strong team',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'team_growth_support',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Coaching conversations', value: 'coaching_conversations' },
                  { label: 'Onboarding support', value: 'onboarding_support' },
                  { label: 'Performance feedback', value: 'performance_feedback' },
                  { label: 'Career development discussions', value: 'career_development_discussions' },
                  { label: 'Learning opportunities', value: 'learning_opportunities' },
                  { label: 'Supporting wellbeing', value: 'supporting_wellbeing' },
               ],
               revieweeLabel: 'How have you supported team growth? (Select all that apply)',
               reviewerLabel: 'Evidence of team development provided (Select all that apply)',
            },
            {
               id: 'team_dev_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // D. Operational & Financial Awareness
      {
         id: 'section_d',
         revieweeTitle: 'Operational & Financial Awareness',
         reviewerTitle: 'Operational & Financial Awareness',
         questions: [
            {
               id: 'ops_effectiveness',
               type: 'radio',
               required: true,
               revieweeLabel: 'How effectively do hospital operations run under your leadership?',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               reviewerLabel: 'HM manages hospital operations',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'ops_strengths',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Staffing & scheduling', value: 'staffing_scheduling' },
                  { label: 'Workflow efficiency', value: 'workflow_efficiency' },
                  { label: 'Use of systems/tools', value: 'systems_tools' },
                  { label: 'Organization & prioritization', value: 'organization_prioritization' },
                  { label: 'Communication & follow-through', value: 'communication_follow_through' },
                  { label: 'Process consistency', value: 'process_consistency' },
               ],
               revieweeLabel: 'Where are you most confident? (Select up to 3)',
               maxSelections: 3,
               reviewerLabel: 'Areas of operational strength (Select up to 3)',
            },
            {
               id: 'kpi_comfort',
               type: 'radio',
               required: true,
               revieweeLabel: 'How comfortable are you with understanding and using hospital performance and KPIs to guide decisions?',
               revieweeOptions: [
                  { label: 'Very comfortable', value: 'very_comfortable' },
                  { label: 'Comfortable', value: 'comfortable' },
                  { label: 'Somewhat comfortable', value: 'somewhat_comfortable' },
                  { label: 'Not comfortable yet', value: 'not_comfortable_yet' },
               ],
               reviewerLabel: 'HM understands, monitors, and acts on financials/KPIs to guide decisions',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'time_focus_areas',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Revenue & visits', value: 'revenue_visits' },
                  { label: 'Labor & payroll', value: 'labor_payroll' },
                  { label: 'Inventory & expenses', value: 'inventory_expenses' },
                  { label: 'Client experience', value: 'client_experience' },
                  { label: 'People & staffing', value: 'people_staffing' },
                  { label: 'Practice growth', value: 'practice_growth' },
               ],
               revieweeLabel: 'Where do you currently spend the majority of your time and focus? (Select all that apply)',
               reviewerLabel: 'Where does the HM appear to spend the majority of their time and focus? (Select all that apply)',
            },
            {
               id: 'ops_fin_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // E. Client Experience & Reputation
      {
         id: 'section_e',
         revieweeTitle: 'Client Experience & Reputation',
         reviewerTitle: 'Client Experience & Reputation',
         questions: [
            {
               id: 'client_experience_confidence',
               type: 'radio',
               required: true,
               revieweeLabel: 'How confident are you in the client experience your hospital delivers?',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Adequate', value: 'adequate' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               reviewerLabel: 'HM ensures positive client experience',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'client_impact',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Service recovery handled effectively', value: 'service_recovery' },
                  { label: 'Team training / staff trained in client engagement', value: 'team_training' },
                  { label: 'Client communication', value: 'client_communication' },
                  { label: 'Reputation maintained or improved', value: 'reputation_improved' },
                  { label: 'Financing & communication handled appropriately', value: 'financing_communication' },
               ],
               revieweeLabel: 'Where have you made the greatest impact? (Select all that apply)',
               hasOther: true,
               reviewerLabel: 'Evidence of impact (Select all that apply)',
            },
            {
               id: 'client_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // F. Partnership & Communication
      {
         id: 'section_f',
         revieweeTitle: 'Partnership & Communication',
         reviewerTitle: 'Partnership & Communication',
         questions: [
            {
               id: 'cos_partnership_rating',
               type: 'radio',
               required: true,
               revieweeLabel: 'Chief of Staff partnership',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Mostly strong', value: 'mostly_strong' },
                  { label: 'Some challenges', value: 'some_challenges' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: 'HM partnership & collaboration with Chief of Staff',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'cos_partnership_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust/connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve partnership with the Chief of Staff? (Select up to 2)',
               maxSelections: 2,
               hasOther: true,
               reviewerLabel: '',
            },
            {
               id: 'rm_partnership_rating',
               type: 'radio',
               required: true,
               revieweeLabel: 'Regional Manager partnership',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Mostly strong', value: 'mostly_strong' },
                  { label: 'Some challenges', value: 'some_challenges' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: 'HM partnership & collaboration with Regional Manager',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'rm_partnership_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust/connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve partnership with the Regional Manager? (Select up to 2)',
               maxSelections: 2,
               hasOther: true,
               reviewerLabel: 'Which partnership behaviors are the strongest? (Select up to 2)',
            },
            {
               id: 'partnership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // G. Resources, Workload & Sustainability
      {
         id: 'section_g',
         revieweeTitle: 'Resources, Workload & Sustainability',
         reviewerTitle: 'Resources, Workload & Sustainability',
         questions: [
            {
               id: 'resources_available',
               type: 'radio',
               required: true,
               revieweeLabel: 'Do you have the tools/resources needed to be effective and use them in a sustainable way?',
               revieweeOptions: [
                  { label: 'Yes, fully', value: 'yes_fully' },
                  { label: 'Mostly', value: 'mostly' },
                  { label: 'Some gaps', value: 'some_gaps' },
                  { label: 'Significant gaps', value: 'significant_gaps' },
               ],
               reviewerLabel: 'HM use of available resources and prioritization/delegation to achieve results',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'resources_to_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Staffing support', value: 'staffing_support' },
                  { label: 'Training/development', value: 'training_development' },
                  { label: 'Technology/tools', value: 'technology_tools' },
                  { label: 'Clearer priorities', value: 'clearer_priorities' },
                  { label: 'Process clarity', value: 'process_clarity' },
                  { label: 'Time for strategic work', value: 'time_for_strategic_work' },
               ],
               revieweeLabel: 'Which resources would improve your effectiveness? (Select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: '',
            },
            {
               id: 'workload_sustainability',
               type: 'radio',
               required: true,
               revieweeLabel: 'How sustainable is your workload?',
               revieweeOptions: [
                  { label: 'Very sustainable', value: 'very_sustainable' },
                  { label: 'Sustainable', value: 'sustainable' },
                  { label: 'Borderline', value: 'borderline' },
                  { label: 'Challenging', value: 'challenging' },
                  { label: 'Unsustainable', value: 'unsustainable' },
               ],
               reviewerLabel: 'HM ability to manage workload in a sustainable way, given current resources and constraints',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'workload_impacts',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Staffing shortages', value: 'staffing_shortages' },
                  { label: 'Volume of responsibilities', value: 'volume_of_responsibilities' },
                  { label: 'Administrative demands', value: 'administrative_demands' },
                  { label: 'Schedule unpredictability', value: 'schedule_unpredictability' },
               ],
               revieweeLabel: 'What impacts your workload the most? (Select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: '',
            },
            {
               id: 'resources_workload_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes (where additional resources are needed vs. where different prioritization or delegation may help)',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // H. Growth & Forward Focus
      {
         id: 'section_h',
         revieweeTitle: 'Growth & Forward Focus',
         reviewerTitle: 'Growth & Forward Focus',
         questions: [
            {
               id: 'growth_pursuit',
               type: 'radio',
               required: true,
               revieweeLabel: '',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               reviewerLabel: 'HM pursues growth and development opportunities',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'development_focus',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Leadership growth', value: 'leadership_growth' },
                  { label: 'Financial/business acumen', value: 'financial_business_acumen' },
                  { label: 'Operations mastery', value: 'operations_mastery' },
                  { label: 'Team development', value: 'team_development' },
                  { label: 'Strategic planning', value: 'strategic_planning' },
                  { label: 'Broader organizational impact', value: 'broader_org_impact' },
               ],
               revieweeLabel: 'Development Focus – Areas I want to grow in next year (Select up to 3)',
               maxSelections: 3,
               hasOther: true,
               reviewerLabel: 'Development Focus – Priority areas to support HM’s continued growth (Select up to 3)',
            },
            {
               id: 'next_year_priorities',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Strengthening leadership impact', value: 'strengthening_leadership_impact' },
                  { label: 'Improving team engagement & retention', value: 'improving_team_engagement_retention' },
                  { label: 'Enhancing operational efficiency', value: 'enhancing_operational_efficiency' },
                  { label: 'Strengthening client experience', value: 'strengthening_client_experience' },
                  { label: 'Improving financial performance', value: 'improving_financial_performance' },
                  { label: 'Creating better sustainability for self and team', value: 'creating_better_sustainability' },
               ],
               revieweeLabel: 'Key Hospital Performance Priorities – Top objectives for next year (Select up to 2)',
               maxSelections: 2,
               reviewerLabel: 'Key Performance Priorities – Top results or initiatives to focus on next year (Select up to 2)',
            },
            {
               id: 'growth_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Optional notes (how I plan to work on the areas)',
               reviewerLabel: 'Optional notes',
            },
         ],
      },

      // I. Overall Performance / Reflection
      {
         id: 'section_i',
         revieweeTitle: 'Overall Reflection',
         reviewerTitle: 'Overall Performance',
         questions: [
            {
               id: 'accomplishments_proud',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Accomplishments I am most proud of this year',
               reviewerLabel: '',
            },
            {
               id: 'anything_else',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Anything else I would like my Regional Manager to know',
               reviewerLabel: '',
            },
            {
               id: 'overall_performance_rating',
               type: 'radio',
               required: true,
               revieweeLabel: '',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               reviewerLabel: 'Overall performance rating',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'overall_additional_comments',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: '',
               reviewerLabel: 'Additional comments',
            },
         ],
      },
   ],
}
